/* 🤖 this file was generated by script */
export const wiconCreditCardDown = {
  name: 'credit_card_down',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 18l3 3m0 0l3-3m-3 3v-6m3-5H2m20 2V8.2c0-1.12 0-1.68-.22-2.1a2 2 0 00-.87-.88C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.1.22a2 2 0 00-.88.87C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.22 2.1.19.38.5.69.87.88.43.22.99.22 2.11.22H12"/></svg>`,
};
